<template>
  <header>
    <nav class="navbar navbar-transparent navbar-absolute-dark navbar-fixed">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <h4>Hypnobirthing.nl</h4>
        </router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import JQuery from "jquery";
const $ = JQuery;

export default {
  mounted() {
    /*===============================================
      Navbar Menu
    ===============================================*/
    var nav = $(".nav");
    var navToggle = $(".nav-toggle-btn");

    //
    // Show Nav menu on Toggle //
    //
    navToggle.on("click", function(e) {
      var d = $(".nav-dropdown");
      var s = $(".sub-dropdown");
      var dMenu = $(".dropdown-menu");
      var sMenu = $(".sub-dropdown-menu");

      if (nav.hasClass("nav-show")) {
        nav.removeClass("nav-show");
        if (dMenu.hasClass("dropdown-menu-show")) {
          dMenu.removeClass("dropdown-menu-show");
          d.removeClass("dropdown-minus");
        }
        if (sMenu.hasClass("sub-dropdown-menu-show")) {
          sMenu.removeClass("sub-dropdown-menu-show");
          s.removeClass("sub-dropdown-minus");
        }
      } else {
        nav.addClass("nav-show");
      }
      e.stopPropagation();
    });

    //
    // Transform Navicon into X //
    //
    navToggle.on("click", function() {
      if (navToggle.hasClass("nav-toggle-close")) {
        navToggle.removeClass("nav-toggle-close");
      } else {
        navToggle.addClass("nav-toggle-close");
      }
    });

    //
    // Navbar Dropdown //
    //
    var dropdownBtn = $(".nav-dropdown .nav-link");
    var subDropdownBtn = $(".sub-dropdown a");

    dropdownBtn.on("click", function() {
      var d = $(this)
        .parent(".nav-dropdown")
        .children(".dropdown-menu");
      if (d.hasClass("dropdown-menu-show")) {
        d.removeClass("dropdown-menu-show");
      } else {
        d.addClass("dropdown-menu-show");
      }
    });

    subDropdownBtn.on("click", function(e) {
      var s = $(this)
        .parent(".sub-dropdown")
        .children(".sub-dropdown-menu");

      if (s.hasClass("sub-dropdown-menu-show")) {
        s.removeClass("sub-dropdown-menu-show");
      } else {
        s.addClass("sub-dropdown-menu-show");
      }
      e.stopPropagation();
    });

    //
    // Transform Plus into Minus //
    //
    dropdownBtn.on("click", function() {
      var m = $(this)
        .parent(".nav-dropdown")
        .children(".dropdown-menu");
      var d = $(this).parent(".nav-dropdown");

      if (m.hasClass("dropdown-menu-show")) {
        d.addClass("dropdown-minus");
      } else {
        d.removeClass("dropdown-minus");
      }
    });

    subDropdownBtn.on("click", function() {
      var m = $(this)
        .parent(".sub-dropdown")
        .children(".sub-dropdown-menu");
      var s = $(this).parent(".sub-dropdown");

      if (m.hasClass("sub-dropdown-menu-show")) {
        s.addClass("sub-dropdown-minus");
      } else {
        s.removeClass("sub-dropdown-minus");
      }
    });

    //
    // Close Nav Menu //
    //
    $(document).on("click", function(e) {
      if ($(e.target).closest(".nav").length === 0) {
        if (nav.hasClass("nav-show")) {
          var d = $(".dropdown-menu");
          var s = $(".sub-dropdown-menu");

          nav.removeClass("nav-show");
          if (d.hasClass("dropdown-menu-show")) {
            d.removeClass("dropdown-menu-show");
            $(".nav-dropdown").removeClass("dropdown-minus");
          }
          if (s.hasClass("sub-dropdown-menu-show")) {
            s.removeClass("sub-dropdown-menu-show");
            $(".sub-dropdown").removeClass("sub-dropdown-minus");
          }
        }
        if (navToggle.hasClass("nav-toggle-close")) {
          navToggle.removeClass("nav-toggle-close");
        }
      }
    });

    //
    // Prevent content jumping to top on click(href='#') //
    //
    $(".navbar a[href='#']").on("click", function(e) {
      e.preventDefault();
    });

    //
    // Position Toggle Button to the left if Nav is aligned left //
    //
    if (nav.hasClass("mr-auto")) {
      navToggle.addClass("left");
    }

    //
    // Sticky Navbar //
    //
    if ($(".navbar-sticky").length) {
      var navbarSticky = $(".navbar-sticky");
      var navbarOffset = navbarSticky.offset().top;

      $(window).on("scroll", function() {
        var navbarPlaceholder = $(".navbar-placeholder");

        if ($(window).scrollTop() >= navbarOffset) {
          navbarSticky.addClass("navbar-sticky-apply");
          navbarPlaceholder.addClass("navbar-placeholder-padding");
        } else {
          navbarSticky.removeClass("navbar-sticky-apply");
          navbarPlaceholder.removeClass("navbar-placeholder-padding");
        }

        if ($(window).scrollTop() >= navbarOffset + 20) {
          navbarSticky.addClass("navbar-shrink");
        } else {
          navbarSticky.removeClass("navbar-shrink");
        }
      });
      // Navbar Sticky Placeholder
      $("<div class='navbar-placeholder'></div>").insertAfter(".navbar-sticky");
    }

    /*===============================================
      Shrink Navbar when starts scrolling
    ===============================================*/
    var navbarFixed = $(".navbar-fixed");

    $(window).on("scroll", function() {
      if ($(window).scrollTop() >= 10) {
        navbarFixed.addClass("navbar-shrink");
      } else {
        navbarFixed.removeClass("navbar-shrink");
      }
    });
  }
};
</script>